import Vue from "vue";
import { Component } from "vue-property-decorator";
import { RequeteurDto } from "../../dto/GenApi.iNotPaie.Dto/RequeteurDto";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { Route } from "vue-router";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Component({
	beforeRouteEnter(to: Route, from: Route, next: any) {
		next(v => {
			const vm = (v as RequeteurTableComponent);
			vm.Init();
		});
	},
	beforeRouteUpdate(to: Route, from: Route, next: any) {
		next();
		(this as RequeteurTableComponent).Init();
	}
})
export default class RequeteurTableComponent extends Vue {
	private requeteur: RequeteurDto | undefined;
	private requeteurToExport: RequeteurDto | undefined;
	public currentOrderColumn = "";
	public orderingDesc = true;

	public Init(): void {
		ServicesFactoryInstance.RequeteurService.getDataId(Number(this.$route.params.id), data => {
			this.requeteur = data;
			this.requeteurToExport = data;
			this.$forceUpdate();
		});
	}

	private ExportDataXLS(): void {
		NotificationServiceInstance.SendInformation("La demande de requête a été prise en compte. Le document sera bientôt disponible");
		ServicesFactoryInstance.RequeteurService.exportDataId(this.requeteur!.Id, (r: Blob) => {
			const libelle = "requete " + this.requeteur!.Name + ".xls";

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(r, libelle);
			} else {
				const link = document.createElement("a");
				document.body.appendChild(link);

				link.href = window.URL.createObjectURL(r);
				link.download = libelle;
				link.click();

				NotificationServiceInstance.SendSuccess("La requête s'est correctement déroulée !");
			}
		});
		this.$forceUpdate();
	}

	private ExportDataPDF(): void {
		// eslint-disable-next-line new-cap
		const doc = new jsPDF();
		const newHeader: any[] = [];
		const newBody: any[] = [];

		for (let i = 0; this.requeteur!.Grid.Columns[i]; i++) {
			newHeader.push(this.requeteur!.Grid.Columns[i].Name);
		}
		for (let i = 0; this.requeteur!.Grid.Row[i]; i++) {
			const temp: any[] = [];
			Object.keys(this.requeteur!.Grid.Row[i]).map((key) => {
				temp.push(this.requeteur!.Grid.Row[i][key]);

				return temp;
			});
			newBody.push(temp);
		}

		autoTable(doc,
			{
				head: [newHeader],
				body: newBody
			});
		doc.save("requete " + this.requeteur!.Name + ".pdf");
	}

	public OrderBy(columnName: string): void {
		if (this.currentOrderColumn == columnName) {
			this.orderingDesc = !this.orderingDesc;
		} else {
			this.orderingDesc = true;
		}
		this.currentOrderColumn = columnName;
		this.DoOrder();
	}

	public DoOrder(): void {
		const orderingDesc = this.orderingDesc;
		const columnName = this.currentOrderColumn;
		if (this.requeteur!.Grid.Row != undefined) {
			this.requeteur!.Grid.Row.sort(function(a: ParametreDto, b: ParametreDto) {
				if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
				if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

				return 0;
			});
		}
	}

	public GetClassOfOrder(columnName: string, desc: boolean): string {
		if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
			return "active";
		}

		return "icons";
	}
}



// WEBPACK FOOTER //
// ./src/components/requeteurTable/requeteurTable.ts